
































import { Component, Vue, Prop } from "vue-property-decorator";
import TableComponent from "@/components/table/TableComponent.vue";
import formatDate from "@/lib/formatDate";

import BatteryTag from "@/basics/icon/BatteryTag.vue";
import CButton from "@/basics/buttons/CButton.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";

@Component({
  components: {
    TableComponent,
    BatteryTag,
    CButton,
    DeleteModal
  }
})
export default class AlertRoomBatteryList extends Vue {
  @Prop({ type: Array, required: true }) items!: any;
  @Prop({ type: String, required: false, default: "" }) flag!: any;

  private deleted: boolean = false;
  private deleteModalFlag:any = {};

  // idを指定してモーダル操作
  // TODO: forceUpdateではないやり方(computedなど）)
  async showModal(id: string) {
    this.deleteModalFlag[id] = true;
    this.$forceUpdate();
  }
  
  async dismissModal(id: string) {
    this.deleteModalFlag[id] = false;
    this.$forceUpdate();
  }

  formatDate(time: number): string {
    return formatDate(new Date(time));
  }

  send(alertId: string) {
    const value = alertId;
    this.$emit("send", value);
  }
}
